// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3R3fL","buttons":"PendingPaymentAlert_buttons__3sREB"};